<template>
  <div id="app">
<!--    <img src="./assets/logo.png">-->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    created () {
      // 页面刷新store数据备份
      if (sessionStorage.getItem('store')) { // 在页面加载时读取sessionStorage里的状态信息
        this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
      }
      window.addEventListener('beforeunload', () => { // 在页面刷新时将vuex里的信息保存到sessionStorage里
        sessionStorage.setItem('store', JSON.stringify(this.$store.state))
      })
    }
  }
}
</script>

<style>
  html,body,#app{
    height: 100%;
  }
  /* 修复 Element UI 图标被全局样式影响的问题 */
  [class^=el-icon-], [class*="el-icon-"] {
    -webkit-transform: none !important;
    transform: none !important;
  }
/*#app {*/
/*  font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
/*  -webkit-font-smoothing: antialiased;*/
/*  -moz-osx-font-smoothing: grayscale;*/
/*  text-align: center;*/
/*  color: #2c3e50;*/
/*  !*margin-top: 60px;*!*/
/*}*/
</style>
